/**
 * Guest Info Popup — StepInStyle
 * Intercepts "Add to Cart" for non-logged-in users,
 * collects name + phone, then proceeds with the add-to-cart.
 * On success, sends lead data to Google Apps Script → Email.
 */

(function () {
  'use strict';

  // ── Config ───────────────────────────────────────────────────────────────

  var WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbwHpaYkqPPYIFAve600igu7HqsSjqdz4xQntZaSF8Gj32zSJvxZQX2V5gbualIoUOEFJQ/exec';

  // ── Helpers ──────────────────────────────────────────────────────────────

  function isLoggedIn() {
    return (
      document.body.classList.contains('customer-logged-in') ||
      window.__st?.cid != null
    );
  }

  function getCookie(name) {
    var m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : undefined;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function hasGuestInfo() {
    return !!getCookie('sis_guest_name') && !!getCookie('sis_guest_phone') && !!getCookie('sis_guest_email');
  }

  // ── Send lead to Google Apps Script (email) ───────────────────────────────

  function sendLeadEmail(name, phone, productTitle, email) {
    var now    = new Date();
    var timeStr = now.toLocaleString('en-US', {
      timeZone: 'Asia/Karachi',
      year:     'numeric',
      month:    'short',
      day:      '2-digit',
      hour:     '2-digit',
      minute:   '2-digit',
      hour12:   true
    });

    var payload = {
      name:    name,
      phone:   phone,
      email:   email || '',
      product: productTitle || window.location.pathname,
      page:    window.location.href,
      time:    timeStr + ' (PKT)'
    };

    // fire-and-forget — use no-cors so CORS preflight doesn't block it
    fetch(WEBHOOK_URL, {
      method: 'POST',
      mode:   'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    }).catch(function(err) {
      console.warn('[SIS] Email webhook failed:', err);
    });
  }

  // ── DOM: create popup once ────────────────────────────────────────────────

  function createPopup() {
    if (document.getElementById('sis-guest-popup')) return;

    var overlay = document.createElement('div');
    overlay.id = 'sis-guest-overlay';
    overlay.className = 'sis-guest-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    var popup = document.createElement('div');
    popup.id = 'sis-guest-popup';
    popup.className = 'sis-guest-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'sis-popup-title');

    popup.innerHTML = `
      <button class="sis-guest-popup__close" aria-label="Close" type="button">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>

      <div class="sis-guest-popup__offer-badge">
        <span class="sis-badge-flat">Flat</span>
        <span class="sis-badge-pct">50<span>%</span><br>OFF</span>
        <div class="sis-badge-extra">
          <span class="sis-badge-plus">+ Extra</span>
          <span class="sis-badge-ten">$10</span>
          <span class="sis-badge-first">for First-Timers!</span>
        </div>
      </div>

      <div class="sis-guest-popup__body">
        <p class="sis-guest-popup__subtitle">One quick step before we bag it for you ✨</p>

        <form id="sis-guest-form" novalidate>
          <div class="sis-guest-popup__field">
            <label for="sis-guest-name">Full Name <span aria-hidden="true">*</span></label>
            <input
              type="text"
              id="sis-guest-name"
              name="guest_name"
              placeholder="e.g. Sara Khan"
              autocomplete="name"
              required
            />
            <span class="sis-field-error" id="sis-name-error"></span>
          </div>

          <div class="sis-guest-popup__field">
            <label for="sis-guest-phone">Phone Number <span aria-hidden="true">*</span></label>
            <input
              type="tel"
              id="sis-guest-phone"
              name="guest_phone"
              placeholder="e.g. +1 234 567 8900"
              autocomplete="tel"
              required
            />
            <span class="sis-field-error" id="sis-phone-error"></span>
          </div>

          <div class="sis-guest-popup__field">
            <label for="sis-guest-email">Email Address <span aria-hidden="true">*</span></label>
            <input
              type="email"
              id="sis-guest-email"
              name="guest_email"
              placeholder="e.g. sara@example.com"
              autocomplete="email"
              required
            />
            <span class="sis-field-error" id="sis-email-error"></span>
          </div>

          <button type="submit" class="sis-guest-popup__submit button">
            <span class="sis-btn-label">Grab My Deal &amp; Add to Cart</span>
            <span class="sis-btn-spinner hidden" aria-hidden="true"></span>
          </button>
        </form>

        <p class="sis-guest-popup__privacy">
          🔒 We respect your privacy. No spam, ever.
        </p>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    // Close button
    popup.querySelector('.sis-guest-popup__close').addEventListener('click', closePopup);

    // Overlay click
    overlay.addEventListener('click', closePopup);

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    // Form submit
    document.getElementById('sis-guest-form').addEventListener('submit', onFormSubmit);
  }

  // ── Open / Close ──────────────────────────────────────────────────────────

  var _pendingFormData = null;
  var _pendingConfig   = null;
  var _pendingProductForm = null;

  function openPopup(productFormEl, formData, config) {
    createPopup();

    _pendingFormData     = formData;
    _pendingConfig       = config;
    _pendingProductForm  = productFormEl;

    var overlay = document.getElementById('sis-guest-overlay');
    var popup   = document.getElementById('sis-guest-popup');

    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('sis-visible');
    popup.classList.add('sis-visible');
    document.body.classList.add('sis-popup-open');

    // Focus first input
    setTimeout(function () {
      var first = popup.querySelector('input');
      if (first) first.focus();
    }, 200);
  }

  // ── Success screen (coupon reveal) ───────────────────────────────────────

  function showSuccessScreen(name) {
    var popup = document.getElementById('sis-guest-popup');
    if (!popup) return;

    popup.innerHTML = `
      <button class="sis-guest-popup__close" aria-label="Close" type="button">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>

      <div class="sis-success-screen">
        <div class="sis-success-screen__top">
          <div class="sis-success-checkmark" aria-hidden="true">
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
              <circle cx="19" cy="19" r="18" stroke="currentColor" stroke-width="1.5" opacity="0.2"/>
              <path d="M11 19.5L16.5 25L27 14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="sis-success-screen__title">You're all set, ${name.split(' ')[0]}! 🎉</h2>
          <p class="sis-success-screen__desc">Your item has been added to the cart.<br>Here's your exclusive first-timer deal:</p>
        </div>

        <div class="sis-coupon-reveal">
          <p class="sis-coupon-reveal__label">Your Discount Code</p>
          <div class="sis-coupon-reveal__box">
            <span class="sis-coupon-reveal__code" id="sis-coupon-code">FIRST10</span>
            <button class="sis-coupon-reveal__copy" type="button" aria-label="Copy code">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
                <path d="M3 11H2.5A1.5 1.5 0 0 1 1 9.5V2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5V3" stroke="currentColor" stroke-width="1.4"/>
              </svg>
              <span class="sis-copy-label">Copy</span>
            </button>
          </div>
          <p class="sis-coupon-reveal__hint">Apply this code at checkout for extra 10% OFF</p>
        </div>

        <div class="sis-success-screen__offer-reminder">
          <span class="sis-offer-pill">Flat 50% OFF</span>
          <span class="sis-offer-plus">+</span>
          <span class="sis-offer-pill sis-offer-pill--red">Extra 10% with FIRST10</span>
        </div>

        <button class="sis-success-screen__cta button" type="button" id="sis-goto-cart">
          View Cart &amp; Checkout →
        </button>
      </div>
    `;

    // Close button
    popup.querySelector('.sis-guest-popup__close').addEventListener('click', closePopup);

    // Copy button
    popup.querySelector('.sis-coupon-reveal__copy').addEventListener('click', function () {
      var code = document.getElementById('sis-coupon-code').textContent;
      navigator.clipboard.writeText(code).then(function () {
        var copyLabel = popup.querySelector('.sis-copy-label');
        copyLabel.textContent = 'Copied!';
        popup.querySelector('.sis-coupon-reveal__copy').classList.add('sis-copied');
        setTimeout(function () {
          copyLabel.textContent = 'Copy';
          popup.querySelector('.sis-coupon-reveal__copy').classList.remove('sis-copied');
        }, 2000);
      }).catch(function () {
        // Fallback for older browsers
        var el = document.createElement('textarea');
        el.value = code;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        var copyLabel = popup.querySelector('.sis-copy-label');
        copyLabel.textContent = 'Copied!';
        setTimeout(function () { copyLabel.textContent = 'Copy'; }, 2000);
      });
    });

    // Go to cart button
    document.getElementById('sis-goto-cart').addEventListener('click', function () {
      closePopup();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        window.location = window.routes.cart_url;
      }
    });
  }

  function closePopup() {
    var overlay = document.getElementById('sis-guest-overlay');
    var popup   = document.getElementById('sis-guest-popup');
    if (!popup) return;

    overlay.classList.remove('sis-visible');
    overlay.setAttribute('aria-hidden', 'true');
    popup.classList.remove('sis-visible');
    document.body.classList.remove('sis-popup-open');

    // Re-enable the submit button that was disabled
    if (_pendingProductForm) {
      var btn = _pendingProductForm.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        var spinner = _pendingProductForm.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    _pendingFormData    = null;
    _pendingConfig      = null;
    _pendingProductForm = null;

    // Clear field errors
    var form = document.getElementById('sis-guest-form');
    if (form) {
      form.querySelectorAll('.sis-field-error').forEach(function(el) { el.textContent = ''; });
      form.querySelectorAll('input').forEach(function(el) { el.classList.remove('sis-input-error'); });
    }
  }

  // ── Form validation & submit ──────────────────────────────────────────────

  function validateForm(form) {
    var valid = true;

    var nameInput  = form.querySelector('#sis-guest-name');
    var phoneInput = form.querySelector('#sis-guest-phone');
    var emailInput = form.querySelector('#sis-guest-email');
    var nameError  = document.getElementById('sis-name-error');
    var phoneError = document.getElementById('sis-phone-error');
    var emailError = document.getElementById('sis-email-error');

    nameError.textContent  = '';
    phoneError.textContent = '';
    emailError.textContent = '';
    nameInput.classList.remove('sis-input-error');
    phoneInput.classList.remove('sis-input-error');
    emailInput.classList.remove('sis-input-error');

    var name  = nameInput.value.trim();
    var phone = phoneInput.value.trim();
    var email = emailInput.value.trim();

    if (!name || name.length < 2) {
      nameError.textContent = 'Please enter your full name (min 2 characters).';
      nameInput.classList.add('sis-input-error');
      valid = false;
    }

    var phoneRegex = /^[\+]?[\d\s\-\(\)]{7,15}$/;
    if (!phone || !phoneRegex.test(phone)) {
      phoneError.textContent = 'Please enter a valid phone number.';
      phoneInput.classList.add('sis-input-error');
      valid = false;
    }

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      emailError.textContent = 'Please enter a valid email address.';
      emailInput.classList.add('sis-input-error');
      valid = false;
    }

    return valid;
  }

  function onFormSubmit(e) {
    e.preventDefault();

    var form = document.getElementById('sis-guest-form');
    if (!validateForm(form)) return;

    var name  = form.querySelector('#sis-guest-name').value.trim();
    var phone = form.querySelector('#sis-guest-phone').value.trim();
    var email = form.querySelector('#sis-guest-email').value.trim();

    // Save to cookies (30 days)
    setCookie('sis_guest_name',  name,  30);
    setCookie('sis_guest_phone', phone, 30);
    setCookie('sis_guest_email', email, 30);

    // Show spinner on popup button
    var submitBtn = form.querySelector('.sis-guest-popup__submit');
    var label     = submitBtn.querySelector('.sis-btn-label');
    var spinner   = submitBtn.querySelector('.sis-btn-spinner');
    submitBtn.disabled = true;
    label.classList.add('hidden');
    spinner.classList.remove('hidden');

    // Attach guest info to cart note via Shopify attributes
    _pendingFormData.append('attributes[Guest Name]',  name);
    _pendingFormData.append('attributes[Guest Phone]', phone);
    _pendingFormData.append('attributes[Guest Email]', email);

    // Proceed with the original cart add
    _pendingConfig.body = _pendingFormData;

    fetch(window.routes.cart_add_url, _pendingConfig)
      .then(function(res) { return res.json(); })
      .then(function(response) {
        submitBtn.disabled = false;
        label.classList.remove('hidden');
        spinner.classList.add('hidden');

        if (response.status) {
          // Error from Shopify
          var phoneError = document.getElementById('sis-phone-error');
          phoneError.textContent = response.description || 'Something went wrong. Please try again.';
          return;
        }

        // Success — show coupon reveal screen instead of closing
        var productTitle = (response.items && response.items[0])
          ? response.items[0].product_title + ' — ' + response.items[0].variant_title
          : window.document.title;

        showSuccessScreen(name);

        // ── Send lead email ──────────────────────────────────────
        sendLeadEmail(name, phone, productTitle, email);
        // ─────────────────────────────────────────────────────────

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }

        // Publish cart update event (for cart icon bubble etc.)
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: _pendingFormData ? _pendingFormData.get('id') : null
          });
        }
      })
      .catch(function(err) {
        console.error('[SIS Guest Popup] Cart add error:', err);
        submitBtn.disabled = false;
        label.classList.remove('hidden');
        spinner.classList.add('hidden');
      });
  }

  // ── Intercept product-form submit ────────────────────────────────────────

  function patchProductForms() {
    // Use MutationObserver so dynamic/quick-add forms are also caught
    function attachIntercept(form) {
      if (form.dataset.sisPatched) return;
      form.dataset.sisPatched = '1';

      form.addEventListener(
        'submit',
        function (evt) {
          // Only intercept when guest is not logged in and info not yet saved
          if (isLoggedIn() || hasGuestInfo()) return;

          // Stop the native submit chain BEFORE product-form.js processes it
          evt.preventDefault();
          evt.stopImmediatePropagation();

          // Replicate what product-form.js does to build the fetch config
          var submitBtn = form.closest('product-form')
            ? form.closest('product-form').querySelector('[type="submit"]')
            : form.querySelector('[type="submit"]');

          if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

          // Show loading state on button
          if (submitBtn) {
            submitBtn.setAttribute('aria-disabled', 'true');
            submitBtn.classList.add('loading');
          }
          var spinner = form.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.remove('hidden');

          var config = {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            }
          };

          var formData = new FormData(form);
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            formData.append('sections', cartDrawer.getSectionsToRender().map(function(s) { return s.id; }));
            formData.append('sections_url', window.location.pathname);
          }

          openPopup(form.closest('product-form') || form, formData, config);
        },
        true // capture phase — fires before product-form.js bubble handler
      );
    }

    // Attach to all existing forms
    document.querySelectorAll('product-form form').forEach(attachIntercept);

    // Watch for dynamically added forms (quick-add modal etc.)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('product-form form')) {
            attachIntercept(node);
          }
          node.querySelectorAll && node.querySelectorAll('product-form form').forEach(attachIntercept);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchProductForms);
  } else {
    patchProductForms();
  }

})();
